import { createSlice } from "@reduxjs/toolkit";
import { resetStore } from "store/actions";

const initialState = {
  dashboard: {
    summary: {},
    top_courses: [],
    classes_by_status: [],
  },
  courses: [],
  classes: [],
  certificates: [],
  airlinePositions: [],
  dashboardFilters: {
    from: "",
    to: "",
    top_courses_limit: 5,
  },
  courseFilters: {
    search: "",
    type: "",
    certificate: "",
    limit: 20,
    page: 1,
    total: 0,
  },
  classFilters: {
    search: "",
    course: "",
    status: "",
    limit: 20,
    page: 1,
    total: 0,
  },
};

const lmsSlice = createSlice({
  name: "lms",
  initialState,
  extraReducers: (builder) => builder.addCase(resetStore, () => initialState),
  reducers: {
    setDashboard: (state, action) => {
      state.dashboard = {
        ...state.dashboard,
        ...(action.payload || {}),
      };
    },
    setDashboardFilters: (state, action) => {
      state.dashboardFilters = {
        ...state.dashboardFilters,
        ...action.payload,
      };
    },
    setCourses: (state, action) => {
      state.courses = action.payload || [];
    },
    setClasses: (state, action) => {
      state.classes = action.payload || [];
    },
    setCertificates: (state, action) => {
      state.certificates = action.payload || [];
    },
    setAirlinePositions: (state, action) => {
      state.airlinePositions = action.payload || [];
    },
    setCourseFilters: (state, action) => {
      state.courseFilters = { ...state.courseFilters, ...action.payload };
    },
    setClassFilters: (state, action) => {
      state.classFilters = { ...state.classFilters, ...action.payload };
    },
  },
});

export const {
  setDashboard,
  setDashboardFilters,
  setCourses,
  setClasses,
  setCertificates,
  setAirlinePositions,
  setCourseFilters,
  setClassFilters,
} = lmsSlice.actions;

export const selLmsDashboard = (state) => state.lms.dashboard;
export const selLmsDashboardFilters = (state) => state.lms.dashboardFilters;
export const selLmsCourses = (state) => state.lms.courses;
export const selLmsClasses = (state) => state.lms.classes;
export const selLmsCertificates = (state) => state.lms.certificates;
export const selLmsAirlinePositions = (state) =>
  state.lms.airlinePositions || [];
export const selLmsCourseFilters = (state) => state.lms.courseFilters;
export const selLmsClassFilters = (state) => state.lms.classFilters;

const reducer = {
  lms: lmsSlice.reducer,
};

export default reducer;
